import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const ConnectivityToolsIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{ width: '24px', height: '24px', ...sx }}
    {...props}
  >
    <path
      d="M21 18h-6.18A3 3 0 0 0 13 16.18V13h7a1 1 0 0 0 0-2h-1V5a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v6H4a1 1 0 0 0 0 2h7v3.18A3 3 0 0 0 9.18 18H3a1 1 0 0 0 0 2h6.18a3 3 0 0 0 5.64 0H21a1 1 0 0 0 0-2ZM7 11V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v6H7Zm5 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
      fill="#fff"
    />
  </SvgIcon>
)

ConnectivityToolsIcon.defaultProps = {
  sx: null,
}
